import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import MUIListItem from '@material-ui/core/ListItem';
import classNames from 'classnames';
const styles = (theme) => createStyles({
    root: {
        padding: 0,
        '&:hover:not($selected)': {
            cursor: 'pointer',
            background: theme.color.grey.lightest,
        },
        '&$inPopover': {
            '&:hover:not($selected)': {
                cursor: 'pointer',
                background: theme.color.grey.default,
                fontWeight: theme.font.weight.normal,
            },
        },
    },
    inPopover: {},
    selected: {
        background: theme.color.primary.main,
        color: theme.color.font.light,
    },
});
const ListItem = (props) => {
    const { classes, className: classNameProp, isSelected, inPopover, testId = 'ListItem', ...other } = props;
    const listItemClass = {
        root: classNames(classes.root, classNameProp, { [classes.inPopover]: inPopover }),
    };
    return (React.createElement(MUIListItem, Object.assign({ "data-testid": `${testId}`, classes: listItemClass, className: classNames(isSelected ? classes.selected : '') }, other)));
};
const ComposedListItem = compose(withStyles(styles, { withTheme: true }), pure)(ListItem);
ComposedListItem.displayName = 'ListItem';
export default ComposedListItem;
//# sourceMappingURL=ListItem.js.map